"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapContainer = exports.ComponentContainer = exports.Loading = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.Loading = (0, styled_1.default)('div') `
  width: 100%;
  height: 100%;
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 3s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 10%,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary_hover')} 40%,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 63%
  );
  background-size: 1000px 640px;
  position: relative;
`;
exports.ComponentContainer = (0, styled_1.default)('div') `
  position: relative;
  width: 100%;
  height: 100%;
`;
exports.MapContainer = (0, styled_1.default)('div') `
  position: absolute;
  overflow: hidden;
  height: ${(props) => (props.isLoaded ? '100%' : 1)};
  width: ${(props) => (props.isLoaded ? '100%' : 1)};

  .marker {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    color: #fff;
    background: ${(0, ui_theme_1.fromTheme)('color_providermatch')};
    border: 1px solid #fff;
    border-radius: 50%;

    /* todo: update this when handling map search */
    &.selected {
      transform: scale(1.2);
    }

    &.nonbookable {
      background: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
    }
  }

  details {
    /* these styles are for the attribution; the values comes from https://healthsparq.atlassian.net/browse/KENG-41581 */
    font-size: 10px;
    color: #999999;
    font-family: arial;
    background: rgba(255, 255, 255, 0.7) !important;
  }
`;
//# sourceMappingURL=styles.js.map